import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { FORM_CONTROL, textInputRootStyles, textInputContentStyles } from './components/common/formControlStyles';

const theme = createTheme({
  components: {
    MuiTextField: { defaultProps: { variant: 'outlined' } },
    MuiFormControl: { defaultProps: { variant: 'outlined' } },
    MuiSelect: {
      defaultProps: { variant: 'outlined' },
      styleOverrides: { icon: { color: '#fff', right: FORM_CONTROL.dropdownInset } },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: textInputRootStyles,
        input: textInputContentStyles,
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'rgba(255,255,255,0.62)',
          '&.Mui-focused': { color: FORM_CONTROL.focus },
          '&.Mui-error': { color: FORM_CONTROL.error },
          '&.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': { transform: `translate(${FORM_CONTROL.textPaddingX}px, ${FORM_CONTROL.textPaddingY}px) scale(1)` },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          '&.fable-selection-button': {
            borderRadius: FORM_CONTROL.radius,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: '50% !important',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          borderRadius: FORM_CONTROL.radius,
          minHeight: FORM_CONTROL.toggleMinHeight,
          color: 'rgba(255,255,255,0.78)',
          backgroundColor: FORM_CONTROL.surface,
          borderColor: FORM_CONTROL.border,
          borderWidth: '2px',
          '&:hover': {
            color: '#fff',
            backgroundColor: FORM_CONTROL.hoverSurface,
          },
          '&.Mui-selected': {
            color: '#fff',
            backgroundColor: FORM_CONTROL.surface,
            borderColor: '#D8A363',
          },
          '&.Mui-selected:hover': {
            color: '#fff',
            backgroundColor: FORM_CONTROL.hoverSurface,
            borderColor: '#E8B373',
          },
          '&.Mui-disabled': {
            color: 'rgba(255,255,255,0.48)',
            backgroundColor: '#1B1E28',
            borderColor: 'rgba(255,255,255,0.12)',
            opacity: 1,
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          left: 'var(--fable-dashboard-modal-left, 0px)',
          right: 'var(--fable-dashboard-modal-right, 0px)',
          width: 'auto',
          overflow: 'hidden',
          transition: 'left 0.22s ease, right 0.22s ease',
          '& .MuiBackdrop-root': {
            position: 'absolute',
          },
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          '&.fable-dashboard-modal': {
            left: 'var(--fable-dashboard-modal-left, 0px)',
            right: 'var(--fable-dashboard-modal-right, 0px)',
            width: 'auto',
            overflow: 'hidden',
            transition: 'left 0.22s ease, right 0.22s ease',
            '& .MuiBackdrop-root': {
              position: 'absolute',
            },
          },
        },
      },
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
